// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-bottom-user-notification[data-v-2293977a]{margin:0 auto;max-width:1000px;width:100%}", ""]);
// Exports
module.exports = exports;
